import React, { useRef } from "react";

import { FlexDiv } from "@/components/Atoms/Box";
import LikeButton from "@/components/Molecules/LikeButton";

import Typography from "@/foundation/Typography/V2";

import {
  CommentAction,
  CommentData,
  CommentHeader,
  CommentWrapper,
  Duration,
  Name,
  ReplyWrapper,
  StyledComment,
  Summary,
} from "./style";
import {
  ActionButton,
  Avatar,
  UserAvatar,
  UserData,
  UserIcon,
  UserInfo,
  UserType,
  VerificationBadge,
} from "../../Post/style";

const SingleComment = ({
  id,
  text: comment,
  posted_by,
  number_of_likes: likes,
  number_of_comments: replies,
  created_timestamp,
  is_liked_by_user: isLiked,
  showBanner,
  reply,
  isReply,
}) => {
  const singleCommentRef = useRef();

  return (
    <StyledComment ref={singleCommentRef}>
      <CommentWrapper>
        <UserInfo>
          {posted_by?.profile_picture ? (
            <Avatar src={posted_by?.profile_picture} />
          ) : (
            <UserAvatar>
              <UserIcon icon="icon-user-avatar" />
            </UserAvatar>
          )}
          <UserData>
            <FlexDiv style={{ gap: "4px", alignItems: "center" }}>
              <Name
                variant="label3"
                fontSize="14px"
                lineHeight="20px"
                fontFamily="var(--man-700)"
                onClick={showBanner}
              >
                {posted_by?.customer_name}
              </Name>
              {posted_by?.is_verified && (
                <VerificationBadge icon="icon-verify" />
              )}
            </FlexDiv>
            {posted_by?.user_type && (
              <FlexDiv style={{ gap: "4px", alignItems: "center" }}>
                <UserType
                  variant="label3"
                  fontSize="12px"
                  lineHeight="16px"
                  fontFamily="var(--man-700)"
                  onClick={showBanner}
                  isShyftUser={
                    posted_by?.user_category?.toLowerCase() === "shyft_expert"
                  }
                >
                  {posted_by?.user_type}
                </UserType>
              </FlexDiv>
            )}
          </UserData>
        </UserInfo>
        <CommentData>
          <CommentHeader>
            <Summary
              variant="span"
              content={comment}
              onUserProfileClick={showBanner}
            />
          </CommentHeader>
          <CommentAction>
            <FlexDiv style={{ gap: "12px" }}>
              <LikeButton
                isLiked={isLiked}
                setIsLiked={showBanner}
                count={likes}
                height={14}
                width={14}
              />
              {!isReply && (
                <ActionButton
                  icon="icon-undo"
                  iconHeight="14px"
                  iconWidth="14px"
                  onClick={showBanner}
                  iconMargin="4px"
                >
                  <Typography
                    variant="label3"
                    fontSize="14px"
                    lineHeight="20px"
                    fontFamily="var(--man-600)"
                  >
                    {replies || 0} Repl{replies > 1 ? `ies` : "y"}
                  </Typography>
                </ActionButton>
              )}
            </FlexDiv>
            <Duration
              variant="label4"
              fontSize="12px"
              lineHeight="16px"
              fontFamily="var(--man-500)"
            >
              {created_timestamp?.display_timestamp || ""}
            </Duration>
          </CommentAction>
          {reply?.length > 0 &&
            reply?.map((comment) => (
              <ReplyWrapper>
                <SingleComment {...comment} showBanner={showBanner} isReply />
              </ReplyWrapper>
            ))}
        </CommentData>
      </CommentWrapper>
    </StyledComment>
  );
};

export default SingleComment;
